<waitLoading *ngIf="isLoading()"></waitLoading>
<p-scrollPanel [style]="{width: '100%', height: '70vh'}" styleClass="custombar1">
  <div class="container-fluid  p-0" *ngIf="!isLoading()">
    <div class="row m-t-xs m-b-lg">
      <div class="col-12 m-b-lg">
        <!-- <p-panel>
          <p-header>
            <span class="leyenda float-right"
              >{{ 'Audit.total' | translate }} {{ types ? types.length : '0' }}
              informes</span
            >
          </p-header> -->
        <!-- <div class="row">
            <div class="col-12">
              <input type="text" class="p-inputtext w-100" placeholder="{{ 'Documents.write.filter' | translate }}" name="filterText" id="filterTextInput" autocomplete="off" [(ngModel)]="filterText" (ngModelChange)="updateFilter()" />
            </div>
          </div> -->
        <p-table [value]="types" [responsive]="true">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th class="col-icon"></th>
              <th class=""></th><!-- Descripcion de la incidencia -->
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-type>
            <tr *ngIf="type.available">
              <td class="col-icon" >
                <span><i class="far fa-file-alt px-1 fa-1-5x"></i><span class="sr-only"></span>
                </span>
              </td>
              <td>
                <span>
                  <a (click)="selectType(type)">{{ type.contractModificationType.description }}</a>
                </span>
                <!--<span *ngIf="!type.available">
                  {{ type.contractModificationType.description }} <b>(En tramitaci�n)</b>
                </span> -->
              </td>
            </tr>
            <tr *ngIf="!type.available">
              <td class="col-icon">
                <span><i class="fas fa-ban px-1 fa-1-5x"></i><span class="sr-only"></span>
                </span>
              </td>
              <td>
                <!--<span class="font-weight-light">-->
                <span>
                  {{ type.contractModificationType.description }}
                </span>
                <b *ngIf="!isProjectReplyca">: {{ type.reason }}</b>
              </td>
            </tr>
          </ng-template>
          <ng-template #contracModificationNotAvailable>
            <td>
              <a (click)="selectType(type)">{{ type.contractModificationType.description }}</a>
            </td>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr class="text-center">
              <td [attr.colspan]="columns.length"> {{ 'General.noFilteredData' | translate }} </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- </p-panel> -->
      </div>
    </div>
  </div>
</p-scrollPanel>